<template>
  <v-dialog class="dialog-quotation" fullscreen persistent hide-overlay v-model="dialog">
    <dialog-customer-list
      :dialog="dialogSelectCustomer"
      :is_edit="false"
      v-on:dialog-close="onDialogCustomerListClose"
    ></dialog-customer-list>

    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-card class="dialog-card platform-font">
      <v-stepper v-model="step" class="elevation-0 quotation-stepper">
        <v-row class="top-layout" no-gutters>
          <v-col cols="2" class="pt-4 pl-3">
            <v-chip
              v-if="company != null && $root.is_admin"
              small
              outlined
              label
              color="black"
              @click="onOpenCustomerList"
            >
              <span class="font-weight-bold black--text caption text-uppercase">
                {{ company.short_name }} -
                {{ newQuotationRequest.currency }}
              </span>
            </v-chip>
          </v-col>

          <v-col>
            <v-stepper-header class="header">
              <v-stepper-step step="1" :complete="step > 1">
                <span class="v-stepper-label">Shipment</span>
              </v-stepper-step>
              <v-stepper-step step="2" :complete="step > 2">
                <span>Add-ons</span>
              </v-stepper-step>
              <v-stepper-step step="3" :complete="step > 3">
                <span>Price breakdown</span>
              </v-stepper-step>
              <!-- <v-stepper-step step="4" :complete="step > 4">
                <span>Sailing schedule</span>
              </v-stepper-step>-->
              <v-stepper-step step="4" :complete="step > 4">
                <span>Required files</span>
              </v-stepper-step>
              <v-stepper-step step="5" :complete="step > 5">
                <span class="v-stepper-label">Review</span>
              </v-stepper-step>
            </v-stepper-header>
          </v-col>

          <v-col cols="2" class="container-btn-alt">
            <!-- <v-btn tile class="btn-alt elevation-0" @click="onDialogClose">Discard</v-btn> -->
            <v-btn
              tile
              outlined
              color="secondary"
              class="font-weight-bold mt-2"
              @click="onDialogClose"
              >DISCARD</v-btn
            >
          </v-col>
        </v-row>

        <!-- Quotation request parameters -->
        <v-stepper-content step="1">
          <form action class="container">
            <v-row class="mb-4">
              <span class="headline primary--text">New Shipment Quotation</span>
            </v-row>

            <!-- First line query -->
            <v-row no-gutters class="pb-4">
              <v-col cols="6">
                <p class="component-header">
                  Shipment type
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" color="primary" size="18"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>FCL: Full Container Load (Containers)</span>
                    <br />
                    <span>LCL: Less Container Load (Boxes or Pallets)</span>
                  </v-tooltip>
                </p>
                <v-btn-toggle
                  class="v-btn-toggle-new-quotation"
                  mandatory
                  dense
                  v-model="newQuotationRequest.quotation_type"
                >
                  <v-btn text :value="CONSTANT.QUOTATION_TYPE_SEA_FCL"
                    >Sea Freight FCL</v-btn
                  >
                  <v-btn text :value="CONSTANT.QUOTATION_TYPE_SEA_LCL"
                    >Sea Freight LCL</v-btn
                  >
                  <v-btn text :value="CONSTANT.QUOTATION_TYPE_AIR">Air Freight</v-btn>
                </v-btn-toggle>
              </v-col>

              <v-col cols="3">
                <p class="component-header">I am an</p>
                <v-btn-toggle
                  mandatory
                  class="v-btn-toggle-new-quotation"
                  dense
                  v-model="newQuotationRequest.transaction_type"
                >
                  <v-btn text value="EXPORT">Exporter</v-btn>
                  <v-btn text value="IMPORT">Importer</v-btn>
                </v-btn-toggle>
              </v-col>

              <v-col cols="3">
                <p class="component-header">Shipping term</p>
                <v-select
                  class="form-control"
                  :items="sortedIncotermList"
                  item-text="label"
                  return-object
                  placeholder="Select shipping term"
                  solo
                  flat
                  v-model="newQuotationRequest.incoterm"
                  style="width: 300px"
                ></v-select>
              </v-col>
            </v-row>

            <!-- FCL  query -->
            <v-row
              no-gutters
              class="px-3 pb-4 mb-4 inset-row input-row"
              v-if="newQuotationRequest.quotation_type == CONSTANT.QUOTATION_TYPE_SEA_FCL"
            >
              <v-col>
                <template v-for="(item, i) in newQuotationRequest.containers">
                  <v-row no-gutters :key="i" class="mb-3">
                    <v-col cols="2" style="padding: 0 100px 0 0px">
                      <p class="component-header">Quantity</p>
                      <input
                        type="number"
                        class="form-control"
                        min="1"
                        id="containerQuantity"
                        v-model="item.container_quantity"
                      />
                    </v-col>

                    <v-col cols="3">
                      <p class="component-header">Container size</p>
                      <v-btn-toggle
                        mandatory
                        class="v-btn-toggle-new-quotation"
                        dense
                        v-model="item.container_size"
                      >
                        <v-btn text value="20">20'</v-btn>
                        <v-btn text value="40">40'</v-btn>
                        <!-- <v-btn text value="40HQ">40' HQ</v-btn> -->
                      </v-btn-toggle>
                    </v-col>

                    <v-col cols="4" style="padding: 0 20px 0 0">
                      <p class="component-header">Container type</p>
                      <v-btn-toggle
                        mandatory
                        class="v-btn-toggle-new-quotation"
                        dense
                        v-model="item.container_type"
                      >
                        <v-btn text value="DRY">Dry</v-btn>
                        <v-btn text value="REEFER">Reefer</v-btn>
                        <v-btn text value="OT">Open Top</v-btn>
                      </v-btn-toggle>
                    </v-col>

                    <v-col>
                      <v-row class="pt-6" justify="end">
                        <v-btn
                          tile
                          outlined
                          class="font-weight-bold mr-4"
                          color="primary"
                          @click="onAddContainer"
                          >Add</v-btn
                        >
                        <v-btn
                          tile
                          outlined
                          class="font-weight-bold"
                          color="error"
                          @click="onRemoveContainer(item)"
                          :disabled="newQuotationRequest.containers.length < 2"
                          >Delete</v-btn
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>

            <!-- LCL or Air query -->
            <v-row no-gutters class="px-3 pb-4 mb-4 inset-row input-row" v-else>
              <v-col>
                <template v-for="(item, i) in newQuotationRequest.cargo_units">
                  <v-row no-gutters :key="i" class="mb-3">
                    <v-col cols="2">
                      <p class="component-header">Quantity</p>
                      <input
                        type="number"
                        class="form-control"
                        min="1"
                        v-model.number="item.quantity"
                        id="containerQuantity"
                        style="max-width: 80px"
                      />
                    </v-col>

                    <v-col class="px-1">
                      <p class="component-header">Packaging type</p>
                      <v-select
                        :items="lcl_packaging_type"
                        placeholder="Select packaging type"
                        solo
                        flat
                        style="max-width: 150px"
                        class="form-control"
                        v-model="item.type"
                      ></v-select>
                    </v-col>

                    <v-col class="px-1">
                      <p class="component-header">Gross weight/unit (kg or lbs)</p>
                      <div class="input-group" style="flex-flow: row wrap">
                        <input
                          type="number"
                          class="form-control"
                          style="max-width: 80px"
                          min="0"
                          v-model.number="item.total_weight"
                        />
                        <v-select
                          class="custom-select form-control"
                          :items="lcl_weight_unit"
                          placeholder="kg"
                          solo
                          flat
                          style="max-width: 80px"
                          v-model="item.weight_unit"
                        ></v-select>
                      </div>
                    </v-col>

                    <v-col class="px-1">
                      <p class="component-header">Cubic meter/unit</p>
                      <div class="input-group" style="flex-flow: row wrap">
                        <input
                          type="number"
                          class="form-control"
                          style="max-width: 150px"
                          v-model.number="item.total_cubic_meters"
                        />
                      </div>
                    </v-col>

                    <v-col>
                      <v-row class="pt-6">
                        <v-btn
                          tile
                          outlined
                          class="font-weight-bold mr-4"
                          color="primary"
                          @click="onAddCargoUnit"
                          >Add</v-btn
                        >
                        <v-btn
                          tile
                          outlined
                          class="font-weight-bold"
                          color="error"
                          @click="onRemoveCargoUnit(item)"
                          :disabled="newQuotationRequest.cargo_units.length < 2"
                          >Delete</v-btn
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>

            <!-- Port query -->
            <v-row no-gutters class="pl-3 pb-4">
              <v-col cols="6">
                <p class="component-header">Origin</p>
                <v-autocomplete
                  class="form-control autocomplete-port"
                  solo
                  flat
                  placeholder="Select origin port"
                  :items="sortedPortList"
                  v-model="newQuotationRequest.origin_port"
                  item-text="label"
                  clearable
                  return-object
                >
                  <template v-slot:item="data">
                    <v-list-item-content style="font-size: 90%">
                      <v-list-item-title v-html="data.item.label"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-slot:item="data">
                    <img
                      :src="CONSTANT.getFlag(data.item.code_country)"
                      class="country-flag"
                    />
                    <v-list-item-content style="font-size: 90%">
                      <v-list-item-title v-html="data.item.label"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="6">
                <p class="component-header">Destination</p>
                <v-autocomplete
                  class="form-control autocomplete-port"
                  solo
                  flat
                  placeholder="Select destination port"
                  :items="sortedPortList"
                  v-model="newQuotationRequest.destination_port"
                  item-text="label"
                  clearable
                  return-object
                >
                  <template v-slot:item="data">
                    <v-list-item-content style="font-size: 90%">
                      <v-list-item-title v-html="data.item.label"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-slot:item="data">
                    <img
                      :src="CONSTANT.getFlag(data.item.code_country)"
                      class="country-flag"
                    />
                    <v-list-item-content style="font-size: 90%">
                      <v-list-item-title v-html="data.item.label"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <!-- Date and cargo type query -->
            <v-row no-gutters class="pl-3 pb-4">
              <v-col cols="3">
                <p class="component-header">Cargo ready date</p>
                <flat-pickr
                  v-model="newQuotationRequest.cargo_ready_date"
                  class="form-control"
                  style="max-width: 200px; background: white"
                  placeholder="Select date"
                  :config="config"
                  name="date"
                ></flat-pickr>
              </v-col>

              <v-col cols="3">
                <p class="component-header">DG-Classification</p>
                <v-select
                  :items="cargoTypeList"
                  placeholder="Select cargo type"
                  class="form-control"
                  solo
                  flat
                  style="max-width: 200px"
                  v-model="newQuotationRequest.cargo_type"
                  item-text="code"
                  item-value="code"
                  return-object
                ></v-select>
              </v-col>

              <v-col cols="3">
                <p class="component-header">Cargo value</p>
                <div class="input-group">
                  <v-select
                    class="custom-select form-control"
                    :items="cargo_value_items"
                    solo
                    flat
                    style="max-width: 90px"
                    v-model="newQuotationRequest.cargo_value_currency"
                  ></v-select>

                  <input
                    type="number"
                    style="max-width: 140px"
                    class="form-control"
                    placeholder="Cargo value"
                    v-model="newQuotationRequest.cargo_value"
                  />
                </div>
              </v-col>

              <v-col cols="3">
                <p class="component-header">HS code</p>
                <div class="input-group">
                  <input
                    type="text"
                    style="width: 50px"
                    class="form-control"
                    placeholder="Example: 40116900"
                    v-model="newQuotationRequest.hs_code"
                  />
                </div>
              </v-col>
            </v-row>

            <!-- Commodity input & Reset & Continue -->
            <v-row no-gutters class="pl-3">
              <v-col cols="4">
                <div class="input-group group-12">
                  <label for>Commodity</label>
                  <textarea
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="2"
                    v-model="newQuotationRequest.commodity"
                    style="padding: 5px"
                  ></textarea>
                </div>
              </v-col>

              <v-col>
                <v-row justify="end" class="pt-6 pr-4">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        text
                        small
                        tile
                        color="secondary"
                        class="font-weight-bold"
                        @click="onReset"
                      >
                        <v-icon size="20" class="mr-1">mdi-restart</v-icon>RESET
                      </v-btn>
                    </template>
                    Reset the quotation parameters
                  </v-tooltip>

                  <v-btn
                    small
                    depressed
                    tile
                    color="primary"
                    class="px-2 ml-2 font-weight-bold"
                    @click="onNext"
                    :disabled="!validateNext(1)"
                  >
                    CONTINUE
                    <v-icon size="20" class="ml-1">mdi-arrow-right-bold-box</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </form>
        </v-stepper-content>

        <!-- Add-ons -->
        <v-stepper-content step="2">
          <form action class="container">
            <v-row class="pl-4">
              <span class="headline primary--text">Add-ons</span>
            </v-row>

            <v-row
              v-if="!CONSTANT.isObjectEmpty(newQuotationRequest.incoterm)"
              no-gutters
            >
              <v-col class="addon-main-col mr-6">
                <v-row no-gutters>
                  <v-col class="col-title">
                    <h4>Customs Clearance</h4>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <img
                          v-on="on"
                          src="@/assets/svg/tooltip.svg"
                          alt
                          class="tooltip-image"
                        />
                      </template>
                      Service for clearance of cargo for export/import at
                      origin/destination port
                    </v-tooltip>
                  </v-col>
                </v-row>

                <v-row class="addon-main-col-row" no-gutters>
                  <v-col>
                    <v-row v-if="show_export_clearance">
                      <v-checkbox
                        hide-details
                        dense
                        v-model="newQuotationRequest.include_customs_clearance_export"
                        :disabled="newQuotationRequest.origin_port == null"
                      >
                        <template v-slot:label>
                          <span
                            class="black--text"
                            v-if="newQuotationRequest.origin_port != null"
                            >Include export customs handling at
                            <b>{{ newQuotationRequest.origin_port.name }}</b></span
                          >

                          <span v-else>Origin port not selected</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                    <v-row v-else no-gutters>
                      <v-col class="px-4">
                        <v-alert
                          dense
                          text
                          border="left"
                          type="info"
                          class="body-2"
                          tile
                          color="primary"
                        >
                          Export clearance is not required for your selected transaction
                          and incoterm
                        </v-alert>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-divider></v-divider>
                    </v-row>

                    <v-row v-if="show_import_clearance">
                      <v-checkbox
                        hide-details
                        dense
                        v-model="newQuotationRequest.include_customs_clearance_import"
                        :disabled="newQuotationRequest.destination_port == null"
                      >
                        <template v-slot:label>
                          <span
                            class="black--text"
                            v-if="newQuotationRequest.destination_port != null"
                            >Include import customs handling at
                            <b>{{ newQuotationRequest.destination_port.name }}</b></span
                          >

                          <span v-else>Destination port not selected</span>
                        </template>
                      </v-checkbox>
                    </v-row>

                    <v-row v-else no-gutters>
                      <v-col class="px-4">
                        <v-alert
                          dense
                          text
                          border="left"
                          type="info"
                          class="body-2"
                          tile
                          color="primary"
                        >
                          Import clearance is not required for your selected transaction
                          and incoterm
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row
                  v-if="
                    newQuotationRequest.quotation_type == CONSTANT.QUOTATION_TYPE_SEA_FCL
                  "
                  no-gutters
                >
                  <v-col>
                    <v-row no-gutters>
                      <v-col class="col-title-inner">
                        <h4>Haulage</h4>
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <img
                              src="@/assets/svg/tooltip.svg"
                              alt
                              class="tooltip-image"
                              v-on="on"
                            />
                          </template>
                          Service for delivering container(s) to location for
                          loading/unloading and pull back to container yard at port
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <v-row class="addon-main-col-row pt-2" no-gutters>
                      <v-col>
                        <v-row no-gutters>
                          <!-- Export Haulage -->
                          <v-col v-if="show_export_haulage">
                            <v-row class="pl-3">
                              <span class="font-weight-bold primary--text subtitle-2"
                                >Export Haulage</span
                              >
                            </v-row>

                            <v-row>
                              <v-checkbox
                                hide-details
                                dense
                                v-model="newQuotationRequest.include_haulage_export"
                              >
                                <template v-slot:label>
                                  <span class="black--text">Include haulage</span>
                                </template>
                              </v-checkbox>

                              <v-checkbox
                                hide-details
                                dense
                                v-model="newQuotationRequest.include_haulage_sdl_export"
                                :disabled="!newQuotationRequest.include_haulage_export"
                              >
                                <template v-slot:label>
                                  <span
                                    :class="
                                      newQuotationRequest.include_haulage_export
                                        ? 'text--primary black--text'
                                        : 'text--disabled'
                                    "
                                    >Side loader</span
                                  >
                                </template>
                              </v-checkbox>

                              <v-checkbox
                                hide-details
                                dense
                                v-model="
                                  newQuotationRequest.use_predefined_haulage_exporter_location
                                "
                                :disabled="!newQuotationRequest.include_haulage_export"
                              >
                                <template v-slot:label>
                                  <span
                                    :class="
                                      newQuotationRequest.include_haulage_export
                                        ? 'text--primary black--text'
                                        : 'text--disabled'
                                    "
                                    >Use predefined locations</span
                                  >
                                </template>
                              </v-checkbox>
                            </v-row>

                            <v-row
                              class="px-4"
                              v-show="
                                newQuotationRequest.use_predefined_haulage_exporter_location
                              "
                            >
                              <label>Haulage city:</label>
                              <v-autocomplete
                                class="form-control"
                                solo
                                flat
                                placeholder="Select city"
                                :items="sortedHaulageExportCitiesList"
                                item-text="name"
                                v-model="newQuotationRequest.city_haulage_export"
                                :disabled="!newQuotationRequest.include_haulage_export"
                                clearable
                                return-object
                              ></v-autocomplete>
                            </v-row>

                            <v-row
                              no-gutters
                              class="px-4"
                              v-show="
                                !newQuotationRequest.use_predefined_haulage_exporter_location
                              "
                            >
                              <v-col>
                                <v-row>
                                  <label>Haulage address:</label>
                                </v-row>
                                <v-row no-gutters>
                                  <v-col>
                                    <input
                                      class="form-control rounded-0"
                                      id="haulage-exporter-autocomplete"
                                      :disabled="
                                        !newQuotationRequest.include_haulage_export
                                      "
                                      v-model="
                                        haulage_exporter_location.formatted_address
                                      "
                                    />
                                  </v-col>
                                  <v-col
                                    cols="1"
                                    v-if="
                                      newQuotationRequest.include_haulage_export &&
                                      haulage_exporter_location.formatted_address !=
                                        null &&
                                      haulage_exporter_location.formatted_address != '' &&
                                      haulage_exporter_location.place_id == null
                                    "
                                  >
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" color="error" size="20"
                                          >mdi-alert-circle</v-icon
                                        >
                                      </template>
                                      Location entered could not be geocoded.
                                    </v-tooltip>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <span
                                    v-if="
                                      haulage_exporter_location.formatted_address !=
                                        null &&
                                      haulage_exporter_location.formatted_address != ''
                                    "
                                    class="font-italic pl-1"
                                  >
                                    {{ haulage_exporter_location.name }}
                                  </span>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col v-else class="px-4">
                            <v-alert
                              dense
                              text
                              border="left"
                              type="info"
                              class="body-2"
                              tile
                              color="primary"
                            >
                              Export haulage is not required for your selected transaction
                              and incoterm
                            </v-alert>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-divider></v-divider>
                        </v-row>

                        <v-row no-gutters>
                          <!-- Import Haulage -->
                          <v-col v-if="show_import_haulage">
                            <v-row class="pl-3">
                              <span class="font-weight-bold primary--text subtitle-2"
                                >Import Haulage</span
                              >
                            </v-row>

                            <v-row>
                              <v-checkbox
                                hide-details
                                dense
                                v-model="newQuotationRequest.include_haulage_import"
                              >
                                <template v-slot:label>
                                  <span class="black--text">Include haulage</span>
                                </template>
                              </v-checkbox>

                              <v-checkbox
                                hide-details
                                dense
                                v-model="newQuotationRequest.include_haulage_sdl_import"
                                :disabled="!newQuotationRequest.include_haulage_import"
                              >
                                <template v-slot:label>
                                  <span
                                    :class="
                                      newQuotationRequest.include_haulage_import
                                        ? 'text--primary'
                                        : 'text--disabled'
                                    "
                                    >Side loader</span
                                  >
                                </template>
                              </v-checkbox>

                              <v-checkbox
                                hide-details
                                dense
                                v-model="
                                  newQuotationRequest.use_predefined_haulage_importer_location
                                "
                                :disabled="!newQuotationRequest.include_haulage_import"
                              >
                                <template v-slot:label>
                                  <span
                                    :class="
                                      newQuotationRequest.include_haulage_import
                                        ? 'text--primary black--text'
                                        : 'text--disabled'
                                    "
                                    >Use predefined locations</span
                                  >
                                </template>
                              </v-checkbox>
                            </v-row>

                            <v-row
                              class="px-4"
                              v-show="
                                newQuotationRequest.use_predefined_haulage_importer_location
                              "
                            >
                              <label>Haulage city:</label>
                              <v-autocomplete
                                class="form-control"
                                solo
                                flat
                                placeholder="Select city"
                                :items="sortedHaulageImportCitiesList"
                                item-text="name"
                                v-model="newQuotationRequest.city_haulage_import"
                                :disabled="!newQuotationRequest.include_haulage_import"
                                clearable
                                return-object
                              ></v-autocomplete>
                            </v-row>

                            <v-row
                              no-gutters
                              class="px-4"
                              v-show="
                                !newQuotationRequest.use_predefined_haulage_importer_location
                              "
                            >
                              <v-col>
                                <v-row>
                                  <label>Haulage address:</label>
                                </v-row>
                                <v-row no-gutters>
                                  <v-col>
                                    <input
                                      class="form-control rounded-0"
                                      id="haulage-importer-autocomplete"
                                      :disabled="
                                        !newQuotationRequest.include_haulage_import
                                      "
                                      v-model="
                                        haulage_importer_location.formatted_address
                                      "
                                    />
                                  </v-col>
                                  <v-col
                                    cols="1"
                                    v-if="
                                      newQuotationRequest.include_haulage_import &&
                                      haulage_importer_location.formatted_address !=
                                        null &&
                                      haulage_importer_location.formatted_address != '' &&
                                      haulage_importer_location.place_id == null
                                    "
                                  >
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" color="error" size="20"
                                          >mdi-alert-circle</v-icon
                                        >
                                      </template>
                                      Location entered could not be geocoded.
                                    </v-tooltip>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <span
                                    v-if="
                                      haulage_importer_location.formatted_address !=
                                        null &&
                                      haulage_importer_location.formatted_address != ''
                                    "
                                    class="font-italic pl-1"
                                  >
                                    {{ haulage_importer_location.name }}
                                  </span>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col v-else class="px-4">
                            <v-alert
                              dense
                              text
                              border="left"
                              type="info"
                              class="body-2"
                              tile
                              color="primary"
                            >
                              Import haulage is not required for your selected transaction
                              and incoterm
                            </v-alert>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row class="addon-option-1" v-else no-gutters>
                  <v-col>
                    <v-row>
                      <v-col class="col-title-inner">
                        <h4>Trucking</h4>
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <img
                              v-on="on"
                              src="@/assets/svg/tooltip.svg"
                              alt
                              class="tooltip-image"
                            />
                          </template>
                          Service for pick-up (or delivery) of cargo from (to) location to
                          (from) port
                        </v-tooltip>
                      </v-col>
                    </v-row>

                    <v-row class="addon-main-col-row pt-2" no-gutters>
                      <v-col>
                        <v-row no-gutters class="pb-2">
                          <!-- Export transport -->
                          <v-col v-if="show_export_transport">
                            <v-row class="pl-3">
                              <span class="font-weight-bold primary--text subtitle-2"
                                >Export Trucking</span
                              >
                            </v-row>

                            <v-row>
                              <v-checkbox
                                hide-details
                                dense
                                v-model="newQuotationRequest.include_transport_export"
                              >
                                <template v-slot:label>
                                  <span class="black--text">Include transport</span>
                                </template>
                              </v-checkbox>

                              <v-checkbox
                                hide-details
                                dense
                                v-model="
                                  newQuotationRequest.use_predefined_transport_exporter_location
                                "
                                :disabled="!newQuotationRequest.include_transport_export"
                              >
                                <template v-slot:label>
                                  <span
                                    :class="
                                      newQuotationRequest.include_transport_export
                                        ? 'text--primary black--text'
                                        : 'text--disabled'
                                    "
                                    >Use predefined locations</span
                                  >
                                </template>
                              </v-checkbox>
                            </v-row>

                            <v-row
                              class="px-4"
                              v-show="
                                newQuotationRequest.use_predefined_transport_exporter_location
                              "
                            >
                              <label>Transport city:</label>
                              <v-autocomplete
                                class="form-control"
                                solo
                                flat
                                placeholder="Select city"
                                :items="sortedTransportExportCitiesList"
                                item-text="name"
                                v-model="newQuotationRequest.city_transport_export"
                                :disabled="!newQuotationRequest.include_transport_export"
                                clearable
                                return-object
                              ></v-autocomplete>
                            </v-row>

                            <v-row
                              no-gutters
                              class="px-4"
                              v-show="
                                !newQuotationRequest.use_predefined_transport_exporter_location
                              "
                            >
                              <v-col>
                                <v-row>
                                  <label>Transport address:</label>
                                </v-row>
                                <v-row no-gutters>
                                  <v-col>
                                    <input
                                      class="form-control rounded-0"
                                      id="transport-exporter-autocomplete"
                                      :disabled="
                                        !newQuotationRequest.include_transport_export
                                      "
                                      v-model="
                                        transport_exporter_location.formatted_address
                                      "
                                    />
                                  </v-col>
                                  <v-col
                                    cols="1"
                                    v-if="
                                      newQuotationRequest.include_transport_export &&
                                      transport_exporter_location.formatted_address !=
                                        null &&
                                      transport_exporter_location.formatted_address !=
                                        '' &&
                                      transport_exporter_location.place_id == null
                                    "
                                  >
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" color="error" size="20"
                                          >mdi-alert-circle</v-icon
                                        >
                                      </template>
                                      Location entered could not be geocoded.
                                    </v-tooltip>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <span
                                    v-if="
                                      transport_exporter_location.formatted_address !=
                                        null &&
                                      transport_exporter_location.formatted_address != ''
                                    "
                                    class="font-italic pl-1"
                                  >
                                    {{ transport_exporter_location.name }}
                                  </span>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col v-else class="px-4">
                            <v-alert
                              dense
                              text
                              border="left"
                              type="info"
                              class="body-2"
                              tile
                              color="primary"
                            >
                              Export transport is not required for your selected
                              transaction and incoterm
                            </v-alert>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-divider></v-divider>
                        </v-row>

                        <v-row no-gutters>
                          <!-- Import transport -->
                          <v-col v-if="show_import_transport">
                            <v-row class="pl-3">
                              <span class="font-weight-bold primary--text subtitle-2"
                                >Import Trucking</span
                              >
                            </v-row>

                            <v-row>
                              <v-checkbox
                                hide-details
                                dense
                                v-model="newQuotationRequest.include_transport_import"
                              >
                                <template v-slot:label>
                                  <span class="black--text">Include transport</span>
                                </template>
                              </v-checkbox>

                              <v-checkbox
                                hide-details
                                dense
                                v-model="
                                  newQuotationRequest.use_predefined_transport_importer_location
                                "
                                :disabled="!newQuotationRequest.include_transport_import"
                              >
                                <template v-slot:label>
                                  <span
                                    :class="
                                      newQuotationRequest.include_transport_import
                                        ? 'text--primary black--text'
                                        : 'text--disabled'
                                    "
                                    >Use predefined locations</span
                                  >
                                </template>
                              </v-checkbox>
                            </v-row>

                            <v-row
                              class="px-4"
                              v-show="
                                newQuotationRequest.use_predefined_transport_importer_location
                              "
                            >
                              <label>Transport city:</label>
                              <v-autocomplete
                                class="form-control"
                                solo
                                flat
                                placeholder="Select city"
                                :items="sortedTransportImportCitiesList"
                                item-text="name"
                                v-model="newQuotationRequest.city_transport_import"
                                :disabled="!newQuotationRequest.include_transport_import"
                                clearable
                                return-object
                              ></v-autocomplete>
                            </v-row>

                            <v-row
                              no-gutters
                              class="px-4"
                              v-show="
                                !newQuotationRequest.use_predefined_transport_importer_location
                              "
                            >
                              <v-col>
                                <v-row>
                                  <label>Transport address:</label>
                                </v-row>
                                <v-row no-gutters>
                                  <v-col>
                                    <input
                                      class="form-control rounded-0"
                                      id="transport-importer-autocomplete"
                                      :disabled="
                                        !newQuotationRequest.include_transport_import
                                      "
                                      v-model="
                                        transport_importer_location.formatted_address
                                      "
                                    />
                                  </v-col>
                                  <v-col
                                    cols="1"
                                    v-if="
                                      newQuotationRequest.include_transport_import &&
                                      transport_importer_location.formatted_address !=
                                        null &&
                                      transport_importer_location.formatted_address !=
                                        '' &&
                                      transport_importer_location.place_id == null
                                    "
                                  >
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" color="error" size="20"
                                          >mdi-alert-circle</v-icon
                                        >
                                      </template>
                                      Location entered could not be geocoded.
                                    </v-tooltip>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <span
                                    v-if="
                                      transport_importer_location.formatted_address !=
                                        null &&
                                      transport_importer_location.formatted_address != ''
                                    "
                                    class="font-italic pl-1"
                                  >
                                    {{ transport_importer_location.name }}
                                  </span>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col v-else class="px-4">
                            <v-alert
                              dense
                              text
                              border="left"
                              type="info"
                              class="body-2"
                              tile
                              color="primary"
                            >
                              Import transport is not required for your selected
                              transaction and incoterm
                            </v-alert>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="5" class="addon-sub-col pl-4 pt-10">
                <!-- <v-row >
                  <v-checkbox
                    hide-details
                    dense
                    v-model="newQuotationRequest.include_letter_of_credit_handling"
                  >
                    <template v-slot:label>
                      <span class="black--text pr-2"
                        >Include letter of credit handling</span
                      >
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <img
                            v-on="on"
                            data-toggle="tooltip"
                            src="@/assets/svg/tooltip.svg"
                            alt
                            class="tooltip-image"
                          />
                        </template>
                        Check here if a letter of credit is the agreed form of
                        transaction between shipper and consignee.
                        <br />The letter of credit will be required to process
                        the bill-of-lading.
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                </v-row> -->

                <v-row v-show="show_telex_release" class="pb-3">
                  <v-checkbox
                    hide-details
                    dense
                    v-model="newQuotationRequest.include_telex_release"
                  >
                    <template v-slot:label>
                      <span class="black--text pr-2">Include telex release</span>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <img
                            v-on="on"
                            data-toggle="tooltip"
                            src="@/assets/svg/tooltip.svg"
                            alt
                            class="tooltip-image"
                          />
                        </template>
                        Delivery of bill-of-lading through telex release service. Telex
                        release facility will be charged on both
                        <br />the exporting and importing party. Do verify that this is
                        the agreed method of delivering the bill-of-lading between both
                        parties.
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                </v-row>

                <v-row v-show="show_insurance" class="py-3">
                  <v-checkbox
                    hide-details
                    dense
                    v-model="newQuotationRequest.include_insurance"
                  >
                    <template v-slot:label>
                      <span class="black--text">Include insurance</span>
                    </template>
                  </v-checkbox>
                </v-row>

                <v-row class="py-3">
                  <v-checkbox
                    hide-details
                    dense
                    v-model="newQuotationRequest.include_other_services"
                  >
                    <template v-slot:label>
                      <span class="black--text">Include additional services</span>
                    </template>
                  </v-checkbox>
                </v-row>

                <v-row>
                  <textarea
                    class="form-control"
                    id="exampleFormControlTextarea2"
                    rows="6"
                    v-model="newQuotationRequest.other_services"
                  ></textarea>
                </v-row>
              </v-col>
            </v-row>

            <v-row style="margin-top: 20px" justify="end">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    text
                    small
                    tile
                    color="secondary"
                    class="font-weight-bold"
                    @click="onReset"
                  >
                    <v-icon size="20" class="mr-1">mdi-restart</v-icon>RESET
                  </v-btn>
                </template>
                Reset the quotation parameters
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    text
                    small
                    tile
                    color="secondary"
                    class="font-weight-bold"
                    @click="onBack"
                  >
                    <v-icon size="20" class="mr-1">mdi-arrow-left-bold-box</v-icon>BACK
                  </v-btn>
                </template>
                Go back to the previous step
              </v-tooltip>

              <v-btn
                small
                depressed
                tile
                color="primary"
                class="px-2 ml-2 font-weight-bold"
                @click="onNext"
              >
                CONTINUE
                <v-icon size="20" class="ml-1">mdi-arrow-right-bold-box</v-icon>
              </v-btn>
            </v-row>
          </form>
        </v-stepper-content>

        <!-- Price breakdown -->
        <v-stepper-content step="3">
          <v-card flat tile class="px-6 pt-2" v-if="draftQuotation != null">
            <v-row no-gutters>
              <v-col>
                <span class="headline primary--text">Price breakdown</span>
              </v-col>
            </v-row>

            <v-row no-gutters class="pl-1">
              <v-col cols="6" v-if="$root.is_admin">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      tile
                      depressed
                      color="primary"
                      class="font-weight-bold px-1"
                      @click="onQuotationRequest"
                    >
                      <v-icon size="16">mdi-calculator</v-icon>RE-CALCULATE
                    </v-btn>
                  </template>
                  Re-calculate Financials
                </v-tooltip>

                <v-btn
                  small
                  tile
                  outlined
                  color="primary"
                  class="font-weight-bold text-sm-caption mx-3 px-1"
                  @click="addNewComponent"
                  >ADD ITEM</v-btn
                >

                <v-btn
                  small
                  tile
                  outlined
                  color="error"
                  class="font-weight-bold text-sm-caption px-1"
                  @click="addDiscountComponent"
                  >ADD DISCOUNT</v-btn
                >
              </v-col>
              <v-col cols="6" v-else></v-col>

              <!-- <v-spacer></v-spacer> -->

              <v-col
                class="pr-4 primary--text"
                v-if="
                  draftQuotation != null &&
                  newQuotationRequest.quotation_type != CONSTANT.QUOTATION_TYPE_SEA_FCL
                "
              >
                <v-row justify="space-between">
                  <span class="caption"
                    >Gross weight/unit: {{ draftQuotation.total_weight }} kg</span
                  >

                  <span class="caption">
                    Cubic meter/unit:
                    {{ draftQuotation.total_cubic_meters }}&#13221;
                  </span>

                  <span
                    v-if="
                      newQuotationRequest.quotation_type == CONSTANT.QUOTATION_TYPE_AIR
                    "
                    class="caption"
                    >Total chargeable weight: {{ draftQuotation.quantity }} kg</span
                  >
                </v-row>
              </v-col>
            </v-row>

            <v-row v-if="draftQuotation.has_complete_price || $root.is_admin">
              <financial-component-table
                v-model="draftQuotation"
                :show-cost="true"
              ></financial-component-table>
            </v-row>

            <v-row
              v-if="!draftQuotation.has_complete_price && !$root.is_admin"
              class="px-4"
            >
              <b>
                We sincerely apologize as we currently do not have the complete rates for
                your requested shipment.
              </b>
              <br />You may continue to save this quotation for your reference. We will
              update you with the rates as soon as possible. At the meantime, should you
              have any inquiries, please feel free to reach out to us at
              <a href="mailto: info@accelefreight.com">info@accelefreight.com</a>
            </v-row>

            <v-row no-gutters class="pl-3 pt-1">
              <v-col cols="6" v-if="$root.is_admin">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      tile
                      depressed
                      color="primary"
                      class="font-weight-bold px-1"
                      @click="onQuotationRequest"
                    >
                      <v-icon size="16">mdi-calculator</v-icon>RE-CALCULATE
                    </v-btn>
                  </template>
                  Re-calculate Financials
                </v-tooltip>

                <v-btn
                  small
                  tile
                  outlined
                  color="primary"
                  class="font-weight-bold text-sm-caption mx-3 px-1"
                  @click="addNewComponent"
                  >ADD ITEM</v-btn
                >

                <v-btn
                  small
                  tile
                  outlined
                  color="error"
                  class="font-weight-bold text-sm-caption px-1"
                  @click="addDiscountComponent"
                  >ADD DISCOUNT</v-btn
                >
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row justify="end">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    text
                    small
                    tile
                    color="secondary"
                    class="font-weight-bold"
                    @click="onReset"
                  >
                    <v-icon size="20" class="mr-1">mdi-restart</v-icon>RESET
                  </v-btn>
                </template>
                Reset the quotation parameters
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    text
                    small
                    tile
                    color="secondary"
                    class="font-weight-bold"
                    @click="onBack"
                  >
                    <v-icon size="20" class="mr-1">mdi-arrow-left-bold-box</v-icon>BACK
                  </v-btn>
                </template>
                Go back to the previous step
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    small
                    depressed
                    tile
                    color="primary"
                    class="px-2 ml-2 mr-5 font-weight-bold"
                    @click="onNext"
                  >
                    CONTINUE
                    <v-icon size="20" class="ml-1">mdi-arrow-right-bold-box</v-icon>
                  </v-btn>
                </template>
                Continue to the next step
              </v-tooltip>
            </v-row>

            <v-divider></v-divider>
          </v-card>

          <v-card flat tile v-else>
            <v-row>
              <v-col>
                <v-alert prominent :type="onRequestError != null ? 'error' : 'info'">
                  <v-row align="center">
                    <v-col v-show="onRequestError != null" class="grow">
                      An error occured while generating the quotation financials:
                      {{ onRequestError }}
                    </v-col>
                    <v-col v-show="onRequestError == null" class="grow"
                      >Please wait...</v-col
                    >
                    <v-col class="shrink">
                      <v-btn
                        v-show="onRequestError != null"
                        class="font-weight-bold text-button"
                        @click="onBack"
                        >Go Back</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-alert>
              </v-col>
            </v-row>
          </v-card>
        </v-stepper-content>

        <!-- Sailing schedule -->
        <!-- <v-stepper-content step="4">
          <v-card flat tile class="px-6 pt-2">
            <div class="no-padding">
              <h1>Sailing schedule</h1>
            </div>
            <div>
              <schedule-list v-model="draftQuotation"></schedule-list>
            </div>
            <v-row style="margin-top: 20px" justify="end">
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-btn
                        v-on="on"
                        text
                        small
                        tile
                        color="secondary"
                        class="font-weight-bold"
                        @click="onReset"
                      >
                        <v-icon size="20" class="mr-1">mdi-restart</v-icon>RESET
                      </v-btn>
                    </template>
                    Reset the quotation parameters
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-btn
                        v-on="on"
                        text
                        small
                        tile
                        color="secondary"
                        class="font-weight-bold"
                        @click="onBack"
                      >
                        <v-icon size="20" class="mr-1">mdi-arrow-left-bold-box</v-icon>BACK
                      </v-btn>
                    </template>
                    Go back to the previous step
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-btn
                        v-on="on"
                        small
                        depressed
                        tile
                        color="primary"
                        class="px-2 font-weight-bold"
                        @click="onNext"
                      >
                        CONTINUE
                        <v-icon size="20" class="ml-1">mdi-arrow-right-bold-box</v-icon>
                      </v-btn>
                    </template>
                    Continue to the next step
                  </v-tooltip>
            </v-row>
          </v-card>
        </v-stepper-content>-->

        <!-- Required files -->
        <v-stepper-content step="4">
          <v-card flat tile class="px-6 pt-2" v-if="draftQuotation != null">
            <quotation-file-upload v-model="draftQuotation"></quotation-file-upload>
            <div class="af-checkbox" v-if="require_files">
              <input type="checkbox" v-model="skipFileCheck" id="fileCheck" />
              <label class for="fileCheck">
                Proceed without file. Required files will be uploaded later to proceed
                with booking of shipment
              </label>
            </div>

            <v-row style="margin-top: 20px" justify="end">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    text
                    small
                    tile
                    color="secondary"
                    class="font-weight-bold"
                    @click="onReset"
                  >
                    <v-icon size="20" class="mr-1">mdi-restart</v-icon>RESET
                  </v-btn>
                </template>
                Reset the quotation parameters
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    text
                    small
                    tile
                    color="secondary"
                    class="font-weight-bold"
                    @click="onBack"
                  >
                    <v-icon size="20" class="mr-1">mdi-arrow-left-bold-box</v-icon>BACK
                  </v-btn>
                </template>
                Go back to the previous step
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    small
                    depressed
                    tile
                    color="primary"
                    class="px-2 font-weight-bold"
                    @click="onNext"
                    :disabled="!enable_file_next"
                  >
                    CONTINUE
                    <v-icon size="20" class="ml-1">mdi-arrow-right-bold-box</v-icon>
                  </v-btn>
                </template>
                Continue to the next step
              </v-tooltip>
            </v-row>
          </v-card>
        </v-stepper-content>

        <!-- Review -->
        <v-stepper-content step="5">
          <v-card flat tile class="px-6 pt-2">
            <v-row no-gutters>
              <v-col>
                <span class="headline primary--text pl-1">Review Quotation</span>
              </v-col>
            </v-row>

            <v-row class="no-padding">
              <quotation-overview
                :quotation="draftQuotationOverview"
                origin="NEW-QUOTATION"
              ></quotation-overview>
            </v-row>

            <v-divider></v-divider>

            <v-row no-gutters>
              <v-col cols="4">
                <span class="body-2 font-weight-bold primary--text"
                  >Quotation Comment</span
                >
                <v-textarea
                  class="modified-text-field caption white"
                  label="Post comment"
                  dense
                  outlined
                  auto-grow
                  hide-details
                  rows="2"
                  row-height="30"
                  clearable
                  v-model="quotation_message"
                ></v-textarea>
              </v-col>

              <v-col>
                <v-row class="pt-6 pb-4" justify="end">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        text
                        small
                        tile
                        color="secondary"
                        class="font-weight-bold"
                        @click="onReset"
                      >
                        <v-icon size="20" class="mr-1">mdi-restart</v-icon>RESET
                      </v-btn>
                    </template>
                    Reset the quotation parameters
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        text
                        small
                        tile
                        color="secondary"
                        class="font-weight-bold"
                        @click="onBack"
                      >
                        <v-icon size="20" class="mr-1">mdi-arrow-left-bold-box</v-icon
                        >BACK
                      </v-btn>
                    </template>
                    Go back to the previous step
                  </v-tooltip>

                  <!-- <v-tooltip top>
                    <template v-slot:activator="{on}">
                      <v-btn
                        v-if="$root.is_admin"
                        v-on="on"
                        outlined
                        small
                        tile
                        color="primary"
                        class="mx-2 px-2 font-weight-bold"
                        @click="onSave(true)"
                      >
                        <v-icon size="20" class="mr-1">mdi-content-save-outline</v-icon>SAVE AS DRAFT
                      </v-btn>
                    </template>
                    Save quotation as draft
                  </v-tooltip>-->

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-if="!$root.is_admin"
                        v-on="on"
                        depressed
                        small
                        tile
                        color="primary"
                        class="mx-2 px-2 font-weight-bold"
                        @click="onSave({ id: 1 })"
                      >
                        <v-icon size="20" class="mr-1">mdi-content-save</v-icon>SAVE
                      </v-btn>
                    </template>
                    Save quotation
                  </v-tooltip>

                  <v-menu
                    v-if="$root.is_admin"
                    open-on-hover
                    top
                    offset-y
                    transition="slide-y-transition"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        depressed
                        small
                        tile
                        color="primary"
                        class="mx-2 pr-0 font-weight-bold"
                      >
                        SAVE
                        <v-icon size="25">mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-item
                        v-for="(item, index) in saveBtns"
                        :key="index"
                        @click="onSave(item)"
                      >
                        <v-list-item-action class="mr-2">
                          <v-icon size="25" color="primary">{{ item.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title
                            class="caption font-weight-bold primary--text"
                            >{{ item.title }}</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-row>
              </v-col>
            </v-row>

            <v-divider></v-divider>
          </v-card>
        </v-stepper-content>
      </v-stepper>
    </v-card>

    <v-dialog v-model="dialogSendQuotation" persistent scrollable max-width="650">
      <v-card tile flat color="white">
        <v-card-title class="dialog-header-title pr-2">
          <v-row no-gutters>
            <v-col>
              <span class="font-weight-bold">Send Quotation</span>
            </v-col>

            <v-col cols="1" class="d-flex justify-content-end">
              <v-icon size="30" color="white" @click="onCloseSaveQuotation"
                >mdi-close</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text class="px-4 pt-4">
          <v-row no-gutters>
            <v-col cols="2">
              <span class="font-weight-bold caption">From:</span>
            </v-col>
            <v-col>
              <span class="font-weight-bold caption">{{ email_data.from }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-divider class="my-3"></v-divider>
          </v-row>

          <v-row>
            <v-text-field
              label="To:"
              :rules="[rules.required, rules.email]"
              hide-details="auto"
              dense
              class="em-text-field body-2 primary--text mb-3"
              outlined
              v-model="email_data.to"
            ></v-text-field>
          </v-row>

          <v-row>
            <v-text-field
              label="Subject:"
              hide-details
              dense
              class="em-text-field body-2 font-weight-bold primary--text mb-3"
              outlined
              v-model="email_data.subject"
            ></v-text-field>
          </v-row>

          <v-row no-gutters class="pt-3">
            <v-col>
              <!-- <vue-editor v-model="email_data.body" :editorToolbar="customToolbar"></vue-editor> -->
              <v-textarea
                class="modified-text-field caption mb-3"
                dense
                outlined
                auto-grow
                hide-details
                rows="10"
                v-model="email_data.body"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row justify="end">
            <v-btn
              color="primary"
              class="font-weight-bold body-2 mr-2"
              depressed
              tile
              dark
              @click="SendQuotationEmail"
              >SEND</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSaveQuotation" persistent max-width="430">
      <v-card tile flat color="white">
        <v-card-text class="pa-0">
          <v-row justify="center">
            <v-alert tile dense type="success" class="body-1" min-width="430">
              Quotation&nbsp;
              <strong>{{ quotation_id }}</strong
              >&nbsp;was successfully created.
            </v-alert>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row justify="end">
            <v-btn
              color="primary"
              class="font-weight-bold"
              depressed
              tile
              dark
              @click="onCloseSaveQuotation"
              >OK</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- On Quotation Request Message -->
    <v-dialog v-model="dialogQuotationRequestMsg" persistent max-width="650">
      <v-card flat tile color="white" v-if="quotationRequestMsg != null">
        <v-card-text class="pt-4 px-2 pb-1">
          <v-alert outlined type="info" prominent border="left">
            <v-row class="title">
              The following rate(s) are not availabe in the pricing table:
            </v-row>
            <v-row>
              <ul>
                <li
                  v-for="(msg, i) in quotationRequestMsg"
                  :key="i"
                  class="text-lg-caption"
                >
                  {{ msg }}
                </li>
              </ul>
            </v-row>
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              tile
              small
              depressed
              color="error"
              class="font-weight-font text-button"
              @click="dialogQuotationRequestMsg = false"
              >CLOSE</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import constant from "../../const";
import firebase from "firebase/app";
import "firebase/firestore";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/airbnb.css";
import QuotationFileUpload from "@/components/shared/QuotationFileUpload.vue";
import DialogCustomerList from "@/components/admin/dialogs/DialogCustomerList.vue";
// import { VueEditor } from "vue2-editor";

export default {
  props: ["dialog"],

  components: {
    QuotationFileUpload,
    flatPickr,
    DialogCustomerList,
    // VueEditor
  },

  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,

      config: {
        altInput: true,
        altInputClass: "flatpickr-alt-input",
        // enableTime: true,
        altFormat: "M j, Y",
        dateFormat: "Y-m-d",
        // time_24hr: true,
        position: "auto",
      },

      dialogSelectCustomer: false,
      dialogSaveQuotation: false,
      dialogQuotationRequestMsg: false,

      quotation_id: null,
      lcl_packaging_type: ["carton", "pallet", "box"],
      lcl_weight_unit: ["kg", "lbs"],
      cargo_value_items: ["USD", "MYR"],

      quotation_message: null,
      quotationCreated: false,
      createdQuotation: null,

      draftQuotation: null,
      quotationRequestMsg: null,
      draftQuotationOverview: null,

      dialogSendQuotation: false,
      email_data: {
        quotation_id: null,
        from: `${this.$root.username} <${this.$root.useraccount.email}>`,
        to: null,
        cc: null,
        bcc: null,
        subject: null,
        body: null,
      },

      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },

      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
      ],

      quotation_total_price: 0.0,

      saveBtns: [
        { id: 0, title: "SAVE AS DRAFT", icon: "mdi-content-save-edit" },
        { id: 1, title: "SAVE ONLY", icon: "mdi-content-save" },
        { id: 2, title: "SAVE & SEND EMAIL", icon: "mdi-content-save-move" },
      ],

      skipFileCheck: false,
      company: null,

      seaPortList: [],
      airPortList: [],
      incotermList: [],
      cargoTypeList: [],

      citiesHaulageExport: [],
      citiesHaulageImport: [],
      citiesTransportExport: [],
      citiesTransportImport: [],

      haulage_exporter_location: {
        name: null,
        formatted_address: null,
      },
      haulage_importer_location: {
        name: null,
        formatted_address: null,
      },
      transport_exporter_location: {
        name: null,
        formatted_address: null,
      },
      transport_importer_location: {
        name: null,
        formatted_address: null,
      },

      haulage_exporter_autocomplete: null,
      haulage_importer_autocomplete: null,
      transport_exporter_autocomplete: null,
      transport_importer_autocomplete: null,

      step: 1,
      onRequestError: null,
      newQuotationRequest: {
        company_id: null, // Only used for admin accounts

        cargo_ready_date: constant.getDate(0),
        schedule_horizon: constant.MINIMUM_HORIZON_WEEKS,
        quotation_type: constant.QUOTATION_TYPE_SEA_FCL,

        origin_port: {},
        destination_port: {},

        cargo_type: {
          code: "NON-DG",
          label: "Non dangerous goods",
        },
        commodity: null,
        transaction_type: "EXPORT",
        currency: "MYR",
        incoterm: {},
        hs_code: null,

        include_customs_clearance_export: false,
        include_customs_clearance_import: false,

        // FCL components
        containers: [
          {
            container_quantity: 1,
            container_size: "20",
            container_type: "DRY",
          },
        ],

        container_total: 0,
        include_haulage_export: false,
        include_haulage_sdl_export: false,
        use_predefined_haulage_exporter_location: false,
        city_haulage_export: {},
        include_haulage_import: false,
        include_haulage_sdl_import: false,
        use_predefined_haulage_importer_location: false,
        city_haulage_import: {},

        // LCL components
        cargo_units: [
          {
            total_cubic_meters: 1,
            total_weight: 100,
            weight_unit: "kg",
            quantity: 1,
            type: "pallet",
          },
        ],
        include_transport_export: false,
        use_predefined_transport_exporter_location: false,
        city_transport_export: {},
        include_transport_import: false,
        use_predefined_transport_importer_location: false,
        city_transport_import: {},

        export_transport_tonnage_rates: [],
        import_transport_tonnage_rates: [],

        include_telex_release: true,
        include_insurance: false,
        include_other_services: false,
        other_services: null,
        include_letter_of_credit_handling: false,

        //Insurance values
        cargo_value: null,
        cargo_value_currency: "USD",
      },
    };
  },
  async created() {
    if (this.dialog) {
      this.quotationCreated = false;
      // When dialog opens
      this.initializeParameters();
    }
  },

  mounted() {},

  watch: {
    // dialog: function () {
    //   if (this.dialog) {
    //     this.quotationCreated = false
    //     // When dialog opens
    //     this.initializeParameters()
    //   }
    // },

    /**
     * listen for changes on the quotation request
     */
    newQuotationRequest: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler(newVal, oldVal) {
        /**
         * upon shipment type toggle,
         * reset the origin and destination port
         */
        if (oldVal.quotation_type != newVal.quotation_type) {
          this.newQuotationRequest.origin_port = {};
          this.newQuotationRequest.destination_port = {};
        }

        // make sure origin port != destination port
        if (
          this.newQuotationRequest.origin_port.un_code != null &&
          this.newQuotationRequest.origin_port.un_code ==
            this.newQuotationRequest.destination_port.un_code
        ) {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = "Origin port cannot be same as destination port";
          this.newQuotationRequest.origin_port = {};
        }

        // make sure origin port != destination port
        if (
          this.newQuotationRequest.destination_port.un_code != null &&
          this.newQuotationRequest.destination_port.un_code ==
            this.newQuotationRequest.origin_port.un_code
        ) {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = "Destination port cannot be same as origin port";
          this.newQuotationRequest.destination_port = {};
        }
      },
    },
  },

  methods: {
    onOpenCustomerList() {
      this.dialogSelectCustomer = true;
    },

    onDialogCustomerListClose(selectedCustomer) {
      this.dialogSelectCustomer = false;
      this.newQuotationRequest.company_id = selectedCustomer.company_id;
      this.company = selectedCustomer;
      this.newQuotationRequest.currency = selectedCustomer.preferred_currency;
    },

    async initializeParameters() {
      // verify user token
      await this.$root.verify_user_token();

      let resp = await this.$https.get("/api/quotations/init");
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.seaPortList = resp.data.data.supported_seaports;
        this.airPortList = resp.data.data.supported_airports;
        this.incotermList = resp.data.data.supported_incoterms;
        this.cargoTypeList = resp.data.data.supported_cargo_types;
      }

      // if afu admin, then pop up company dialog for selection
      if (this.$root.is_admin || this.$root.is_afu_admin) {
        this.dialogSelectCustomer = true;
      } else if (this.$root.is_company_approved) {
        this.newQuotationRequest.company_id = this.$root.company_id;
      } else {
        this.$root.logout();
      }

      this.step = 1;
      // this.onReset();
    },

    /**
     * Reset quotation
     */

    onReset() {
      // this.$store.commit("newQuotation/reset")
      this.newQuotationRequest = {
        company_id: null, // Only used for admin accounts

        cargo_ready_date: constant.getDate(0),
        schedule_horizon: constant.MINIMUM_HORIZON_WEEKS,
        quotation_type: constant.QUOTATION_TYPE_SEA_FCL,

        origin_port: {},
        destination_port: {},

        cargo_type: {
          code: "NON-DG",
          label: "Non dangerous goods",
        },
        commodity: null,
        transaction_type: "EXPORT",
        currency: "MYR",
        incoterm: {},
        hs_code: null,

        include_customs_clearance_export: false,
        include_customs_clearance_import: false,

        // FCL components
        containers: [
          {
            container_quantity: 1,
            container_size: "20",
            container_type: "DRY",
          },
        ],

        container_total: 0,
        include_haulage_export: false,
        include_haulage_sdl_export: false,
        use_predefined_haulage_exporter_location: false,
        city_haulage_export: {},
        include_haulage_import: false,
        include_haulage_sdl_import: false,
        use_predefined_haulage_importer_location: false,
        city_haulage_import: {},

        // LCL components
        // packing_quantity: 1,
        // packing_type: "pallet",
        // total_weight: 100,
        // weight_unit: "kg",
        // total_cubic_meters: 1,

        // LCL components
        cargo_units: [
          {
            total_cubic_meters: 1,
            total_weight: 100,
            weight_unit: "kg",
            quantity: 1,
            type: "pallet",
          },
        ],
        include_transport_export: false,
        use_predefined_transport_exporter_location: false,
        city_transport_export: {},
        include_transport_import: false,
        use_predefined_transport_importer_location: false,
        city_transport_import: {},

        export_transport_tonnage_rates: [],
        import_transport_tonnage_rates: [],

        include_telex_release: true,
        include_insurance: false,
        include_other_services: false,
        other_services: null,
        include_letter_of_credit_handling: false,

        //Insurance values
        cargo_value: null,
        cargo_value_currency: "USD",
      };
      this.initializeParameters();
    },

    onBack: function (event) {
      if (this.step > 1) this.step--;
    },

    onNext() {
      switch (this.step) {
        case 1:
          if (
            this.newQuotationRequest.origin_port.un_code ==
            this.newQuotationRequest.destination_port.un_code
          ) {
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = "Origin port cannot be same as Destination port";
            return;
          }
          this.initializeAddOns();
          this.setTelexReleaseDefault();
          this.step++;
          break;
        case 2:
          this.onQuotationRequest();
          this.step++;
          break;
        case 3:
          this.step++;
          break;
        // case 3:
        //   this.step++;
        //   break;
        case 4:
          this.onQuotationReview();
          this.step++;
          break;
        default:
          this.step++;
          break;
      }
    },

    validateNext() {
      var validate = false;

      switch (this.step) {
        case 1:
          validate =
            this.newQuotationRequest.quotation_type != null &&
            this.newQuotationRequest.origin_port.un_code != null &&
            this.newQuotationRequest.destination_port.un_code != null &&
            this.newQuotationRequest.incoterm.incoterm != null &&
            this.newQuotationRequest.cargo_ready_date != null;
        default:
          break;
      }

      return validate;
    },

    /** Add a new container info */
    onAddContainer() {
      this.newQuotationRequest.containers.push({
        container_quantity: 1,
        container_size: "20",
        container_type: "DRY",
      });
    },

    /** Remove selected container info */
    onRemoveContainer(container) {
      this.newQuotationRequest.containers = this.newQuotationRequest.containers.filter(
        function (ele) {
          return ele != container;
        }
      );
    },

    /** Add a new cargo unit info */
    onAddCargoUnit() {
      this.newQuotationRequest.cargo_units.push({
        total_cubic_meters: 1,
        total_weight: 100,
        weight_unit: "kg",
        quantity: 1,
        type: "pallet",
      });
    },

    /** Remove selected cargo unit info */
    onRemoveCargoUnit(cargo_unit) {
      this.newQuotationRequest.cargo_units = this.newQuotationRequest.cargo_units.filter(
        function (ele) {
          return ele != cargo_unit;
        }
      );
    },

    getFlag(flagName) {
      try {
        return require(`@/assets/flags/4x3/${flagName.toLowerCase()}.svg`);
      } catch (e) {
        return require("@/assets/flags/4x3/undefined.svg");
      }
    },

    initializeAddOns() {
      var response = null;
      this.citiesHaulageExport = [];
      this.citiesHaulageImport = [];
      this.citiesTransportExport = [];
      this.citiesTransportImport = [];

      if (
        this.newQuotationRequest.quotation_type == this.CONSTANT.QUOTATION_TYPE_SEA_FCL
      ) {
        if (this.show_export_haulage) {
          // init haulage exporter address autocomplete
          this.initHaulageExporterAddressAutocomplete();

          this.$https
            .get(
              constant.API_HOST +
                "/api/pts/haulage/cities/" +
                this.newQuotationRequest.origin_port.un_code
            )
            .then((resp) => (response = resp.data))
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              if (response != null && response.status == constant.RESPONSE_STATUS_OK) {
                this.citiesHaulageExport = response.data;
              } else if (response.status == constant.RESPONSE_STATUS_EMPTY) {
                this.citiesHaulageExport = response.data;
              } else {
                console.log("Error initializing export haulage:", response);
              }
            });
        }

        if (this.show_import_haulage) {
          // init haulage importer address autocomplete
          this.initHaulageImporterAddressAutocomplete();

          this.$https
            .get(
              constant.API_HOST +
                "/api/pts/haulage/cities/" +
                this.newQuotationRequest.destination_port.un_code
            )
            .then((resp) => (response = resp.data))
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              if (response != null && response.status == constant.RESPONSE_STATUS_OK) {
                this.citiesHaulageImport = response.data;
              } else if (response.status == constant.RESPONSE_STATUS_EMPTY) {
                this.citiesHaulageImport = response.data;
              } else {
                console.log("Error initializing import haulage:", response);
              }
            });
        }
      } else if (
        this.newQuotationRequest.quotation_type == this.CONSTANT.QUOTATION_TYPE_SEA_LCL ||
        this.newQuotationRequest.quotation_type == this.CONSTANT.QUOTATION_TYPE_AIR
      ) {
        if (this.show_export_transport) {
          // init transport exporter address autocomplete
          this.initTransportExporterAddressAutocomplete();

          this.$https
            .get(
              constant.API_HOST +
                "/api/pts/transport/cities/" +
                this.newQuotationRequest.origin_port.un_code
            )
            .then((resp) => (response = resp.data))
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              if (response != null && response.status == constant.RESPONSE_STATUS_OK) {
                this.citiesTransportExport = response.data;
              } else if (response.status == constant.RESPONSE_STATUS_EMPTY) {
                this.citiesTransportExport = response.data;
              } else {
                console.log("Error initializing export transport:", response);
              }
            });
        }

        if (this.show_import_transport) {
          // init transport importer address autocomplete
          this.initTransportImporterAddressAutocomplete();

          this.$https
            .get(
              constant.API_HOST +
                "/api/pts/transport/cities/" +
                this.newQuotationRequest.destination_port.un_code
            )
            .then((resp) => (response = resp.data))
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              if (response != null && response.status == constant.RESPONSE_STATUS_OK) {
                this.citiesTransportImport = response.data;
              } else if (response.status == constant.RESPONSE_STATUS_EMPTY) {
                this.citiesTransportImport = response.data;
              } else {
                console.log("Error initializing import transport:", response);
              }
            });
        }
      }
    },

    /**
     * Set telex release to default based on the incoterm
     */
    setTelexReleaseDefault() {
      // if show telex release is false, then include telexe release should be false
      this.newQuotationRequest.include_telex_release = this.show_telex_release;
    },

    //* Haulage Address Mapping

    /** Haulage Exporter's Address autocomplete */
    initHaulageExporterAddressAutocomplete() {
      this.haulage_exporter_autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("haulage-exporter-autocomplete"),
        {
          componentRestrictions: {
            country: this.newQuotationRequest.origin_port.code_country.toLowerCase(),
          },
        }
      );
      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      this.haulage_exporter_autocomplete.setFields([
        "address_components",
        "formatted_address",
        "geometry",
        "place_id",
        "name",
        "types",
        // "plus_code",
      ]);
      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      this.haulage_exporter_autocomplete.addListener(
        "place_changed",
        this.haulageExporterFillInAddress
      );
    },

    /** Haulage Importer's Address autocomplete */
    initHaulageImporterAddressAutocomplete() {
      this.haulage_importer_autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("haulage-importer-autocomplete"),
        {
          componentRestrictions: {
            country: this.newQuotationRequest.destination_port.code_country.toLowerCase(),
          },
        }
      );
      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      this.haulage_importer_autocomplete.setFields([
        "address_components",
        "formatted_address",
        "geometry",
        "place_id",
        "name",
        "types",
        // "plus_code",
      ]);
      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      this.haulage_importer_autocomplete.addListener(
        "place_changed",
        this.haulageImporterFillInAddress
      );
    },

    /**
     * Haulage Exporter Fill in the address information
     */
    haulageExporterFillInAddress() {
      // Get the place details from the autocomplete object.
      const place = this.haulage_exporter_autocomplete.getPlace();

      // update the city geocode data
      this.haulage_exporter_location.address_components = place.address_components;
      this.haulage_exporter_location.formatted_address = place.formatted_address;
      this.haulage_exporter_location.place_id = place.place_id;
      this.haulage_exporter_location.name = place.name;
      this.haulage_exporter_location.types = place.types;
      this.haulage_exporter_location.geometry = {
        location: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      };
    },

    /**
     * Haulage Importer Fill in the address information
     */
    haulageImporterFillInAddress() {
      // Get the place details from the autocomplete object.
      const place = this.haulage_importer_autocomplete.getPlace();

      // update the city geocode data
      this.haulage_importer_location.address_components = place.address_components;
      this.haulage_importer_location.formatted_address = place.formatted_address;
      this.haulage_importer_location.place_id = place.place_id;
      this.haulage_importer_location.name = place.name;
      this.haulage_importer_location.types = place.types;
      this.haulage_importer_location.geometry = {
        location: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      };
    },

    //* Transport Address Mapping

    /** Transport Exporter's Address autocomplete */
    initTransportExporterAddressAutocomplete() {
      this.transport_exporter_autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("transport-exporter-autocomplete"),
        {
          componentRestrictions: {
            country: this.newQuotationRequest.origin_port.code_country.toLowerCase(),
          },
        }
      );
      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      this.transport_exporter_autocomplete.setFields([
        "address_components",
        "formatted_address",
        "geometry",
        "place_id",
        "name",
        "types",
        // "plus_code",
      ]);
      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      this.transport_exporter_autocomplete.addListener(
        "place_changed",
        this.transportExporterFillInAddress
      );
    },

    /** Transport Importer's Address autocomplete */
    initTransportImporterAddressAutocomplete() {
      this.transport_importer_autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("transport-importer-autocomplete"),
        {
          componentRestrictions: {
            country: this.newQuotationRequest.destination_port.code_country.toLowerCase(),
          },
        }
      );
      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      this.transport_importer_autocomplete.setFields([
        "address_components",
        "formatted_address",
        "geometry",
        "place_id",
        "name",
        "types",
        // "plus_code",
      ]);
      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      this.transport_importer_autocomplete.addListener(
        "place_changed",
        this.transportImporterFillInAddress
      );
    },

    /**
     * Transport Exporter Fill in the address information
     */
    transportExporterFillInAddress() {
      // Get the place details from the autocomplete object.
      const place = this.transport_exporter_autocomplete.getPlace();

      // update the city geocode data
      this.transport_exporter_location.address_components = place.address_components;
      this.transport_exporter_location.formatted_address = place.formatted_address;
      this.transport_exporter_location.place_id = place.place_id;
      this.transport_exporter_location.name = place.name;
      this.transport_exporter_location.types = place.types;
      this.transport_exporter_location.geometry = {
        location: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      };
    },

    /**
     * Transport Importer Fill in the address information
     */
    transportImporterFillInAddress() {
      // Get the place details from the autocomplete object.
      const place = this.transport_importer_autocomplete.getPlace();

      // update the city geocode data
      this.transport_importer_location.address_components = place.address_components;
      this.transport_importer_location.formatted_address = place.formatted_address;
      this.transport_importer_location.place_id = place.place_id;
      this.transport_importer_location.name = place.name;
      this.transport_importer_location.types = place.types;
      this.transport_importer_location.geometry = {
        location: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      };
    },

    /**
     * On quotation request
     */
    async onQuotationRequest() {
      this.draftQuotation = null;
      this.onRequestError = null;

      if (
        this.newQuotationRequest.quotation_type == this.CONSTANT.QUOTATION_TYPE_SEA_FCL
      ) {
        this.newQuotationRequest.exporter_location = this.haulage_exporter_location;
        this.newQuotationRequest.importer_location = this.haulage_importer_location;
      } else {
        this.newQuotationRequest.exporter_location = this.transport_exporter_location;
        this.newQuotationRequest.importer_location = this.transport_importer_location;
      }

      // if show insurance is false, then include insurance should be false
      if (!this.show_insurance) {
        this.newQuotationRequest.include_insurance = false;
      }

      // if show telex release is false, then include telexe release should be false
      if (!this.show_telex_release) {
        this.newQuotationRequest.include_telex_release = false;
      }

      this.$root.blockUIshow = true;
      this.$root.blockUImsg = "Requesting quotation";

      let resp = await this.$https.post(
        "/api/quotations/request",
        this.newQuotationRequest
      );
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.draftQuotation = resp.data.data;
        // console.log("quotation: ", this.draftQuotation)

        // if there is an extra message about this quotation request
        if (
          this.$root.is_admin &&
          this.draftQuotation.hasOwnProperty("pricing_info") &&
          this.draftQuotation.pricing_info.length > 0
        ) {
          this.quotationRequestMsg = this.draftQuotation.pricing_info;
          this.dialogQuotationRequestMsg = true;
        }
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
        this.onRequestError = resp.data.msg;
        console.log("Error on quotation request", resp.data);
      }
      this.$root.blockUIshow = false;
    },

    /**
     * Add discount/rebate component to FC
     */
    addDiscountComponent() {
      this.draftQuotation.estimate_component.push({
        type: constant.TYPE_DISCOUNT_REBATE,
        code: "OT-REB",
        conversion_factor: 1.0,
        cost: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        currency: this.draftQuotation.currency,
        description: "Discount/rebate description",
        price: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        quantity: 1,
        uom: "SET",
      });
    },

    /**
     * Add a general item component to FC
     */
    addNewComponent() {
      this.draftQuotation.estimate_component.push({
        type: constant.TYPE_GENERAL_ITEM,
        code: "OT-GEN",
        conversion_factor: 1.0,
        cost: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        currency: this.draftQuotation.currency,
        description: "General item",
        price: {
          base: 0.0,
          min: 0.0,
          per_unit: 0.0,
          converted: 0.0,
        },
        quantity: 1,
        uom: "SET",
      });
    },

    onQuotationReview() {
      this.draftQuotationOverview = JSON.parse(JSON.stringify(this.draftQuotation));
    },

    /**
     * On Save quotation
     */
    onSave(item) {
      this.$root.blockUImsg = "Please wait...";
      this.$root.blockUIshow = true;
      let url = "/api/quotations/save";

      switch (item.id) {
        // Save Quotation as a Draft
        case 0:
          this.$root.blockUImsg = "Saving quotation as draft";
          url = "/api/quotations/save/draft";
          this.saveQuotation(url, false);
          break;

        // Save Quotation Only as Request
        case 1:
          this.$root.blockUImsg = "Saving quotation";
          url = "/api/quotations/save";
          this.saveQuotation(url, false);
          break;

        // Save Quotation and Send Email
        case 2:
          this.$root.blockUImsg = "please wait...";
          url = "/api/quotations/save";
          this.saveQuotation(url, true);
          break;

        default:
          break;
      }
    },

    /**
     * Save this quotation
     */
    saveQuotation(url, email = false) {
      var response = null;

      this.$https
        .post(url, this.draftQuotation)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          if (response != null && response.status == constant.RESPONSE_STATUS_OK) {
            this.createdQuotation = response.data;
            this.quotation_id = this.createdQuotation.quotation_id;
            this.quotation_total_price = this.createdQuotation.price_estimate_total;

            // only post if the quotation message is not null
            if (this.quotation_message != null) {
              // post quotation comment message
              this.postMessage(this.createdQuotation);
            }

            this.quotationCreated = true;

            // if email is true
            if (email) {
              this.email_data.quotation_id = this.quotation_id;
              this.email_data.to = this.company.contact_info.email;
              this.email_data.subject = `Quotation ${this.quotation_id} from Accele Freight Sdn Bhd`;
              this.email_data.body = `Hi ${this.company.contact_info.first_name || ""},
Thank you for your enquiry.

Attached is your Quotation ${this.quotation_id} for ${
                this.newQuotationRequest.currency
              } ${this.quotation_total_price.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}.

If you have any questions, please let us know.
Thanks,
Accele Freight Sdn Bhd
Terms`;

              // open quotation email dialog
              this.dialogSendQuotation = true;
            } else {
              // open success save dialog
              this.dialogSaveQuotation = true;
            }
          } else {
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = response.msg;
            console.log("Error saving quotation", response);
          }

          this.$root.blockUIshow = false;
        });
    },

    /**
     * Post message to firestore
     */
    postMessage(quotation) {
      var db = this.$root.messageCenterApp.firestore();
      var d = new Date();

      // compose the comment object
      let comment = {
        comment_id: null,
        quotation_id: quotation.quotation_id,
        invoice_id: null,
        category: "quotation",
        company_id: quotation.company.company_id,
        company_name: quotation.company.name,
        tags: [
          `${quotation.quotation_type.toLowerCase()}`,
          `${quotation.transaction_type.toLowerCase()}`,
          `${quotation.incoterm.toLowerCase()}`,
          `${quotation.cargo_type_code.toLowerCase()}`,
        ],
        message: this.quotation_message,
        first_name: this.$root.useraccount.first_name,
        last_name: this.$root.useraccount.last_name,
        email: this.$root.useraccount.email,
        uid: this.$root.useraccount.uid,
        account_type: this.$root.useraccount.account_type,
        restricted: false,
        createdStr: `${d.getFullYear()}-${
          d.getMonth() + 1
        }-${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`,
        created: firebase.firestore.FieldValue.serverTimestamp(),
      };

      // write a new comment message
      db.collection("comments")
        .doc(quotation.quotation_id)
        .collection("messages")
        .add(comment)
        .then((docRef) => {
          this.quotation_message = null;

          // update comment id
          db.collection("comments")
            .doc(quotation.quotation_id)
            .collection("messages")
            .doc(docRef.id)
            .update({
              comment_id: docRef.id,
            });

          // Get the doc for this quotation
          // TO check if this is the first comment message
          db.collection("comments")
            .doc(quotation.quotation_id)
            .get()
            .then((doc) => {
              // if doc is empty
              if (!doc.exists) {
                // set the message count
                db.collection("comments").doc(quotation.quotation_id).set({
                  count: 1,
                });
              } else {
                // update the message count
                db.collection("comments")
                  .doc(quotation.quotation_id)
                  .update({
                    count: firebase.firestore.FieldValue.increment(1),
                  });
              }
            });
        })
        .catch((error) => {
          console.error("Error adding document: ", error);
        });
    },

    /**
     * On send quotation email
     */
    SendQuotationEmail() {
      this.$root.blockUIshow = true;
      this.$root.blockUImsg = "Sending quotation";

      var response = null;

      this.$https
        .post("/api/quotations/send_email", this.email_data)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          if (response != null && response.status == constant.RESPONSE_STATUS_OK) {
            this.showSnackbar = true;
            this.snackbarColor = "success";
            this.snackbarMsg = "Quotation Email Sent";

            this.$root.blockUIshow = false;

            this.dialogSendQuotation = false;
            // this.onDialogClose();
          } else {
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = response.msg;
            console.log("Error sending quotation", response);
            this.$root.blockUIshow = false;
          }
          this.$root.blockUIshow = false;
        });
    },

    /**
     * On close the save quotation
     */
    onCloseSaveQuotation() {
      this.dialogSaveQuotation = false;
      this.onDialogClose();
    },

    /**
     * On close the new quotation dialog
     */
    onDialogClose() {
      this.dialogSelectCustomer = false;
      this.$store.commit("newQuotation/reset");
      this.step = 1;
      this.$emit("dialog-close", this.createdQuotation, this.quotationCreated);
    },
  },

  computed: {
    sortedPortList: function () {
      if (this.newQuotationRequest.quotation_type == constant.QUOTATION_TYPE_AIR) {
        return this.airPortList.sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
      } else {
        return this.seaPortList.sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
      }
    },

    sortedIncotermList: function () {
      return this.incotermList.sort(function (a, b) {
        return a.incoterm.localeCompare(b.incoterm);
      });
    },

    sortedHaulageExportCitiesList: function () {
      return this.citiesHaulageExport.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },

    sortedHaulageImportCitiesList: function () {
      return this.citiesHaulageImport.sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
    },

    sortedTransportExportCitiesList: function () {
      return this.citiesTransportExport.sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
    },

    sortedTransportImportCitiesList: function () {
      return this.citiesTransportImport.sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
    },

    // Additional information to be shown based on shipment type and incoterms

    show_export_clearance: {
      get() {
        if (
          this.newQuotationRequest.transaction_type == null ||
          Object.keys(this.newQuotationRequest.incoterm).length === 0
        ) {
          return false;
        }

        return (
          this.newQuotationRequest.incoterm.responsibilities.export_clearance ==
          this.newQuotationRequest.transaction_type
        );
      },
    },

    show_import_clearance: {
      get() {
        if (
          this.newQuotationRequest.transaction_type == null ||
          Object.keys(this.newQuotationRequest.incoterm).length === 0
        ) {
          return false;
        }

        return (
          this.newQuotationRequest.incoterm.responsibilities.import_clearance ==
          this.newQuotationRequest.transaction_type
        );
      },
    },

    /**
     * Decision made by both entity (Export local charges)
     */
    show_telex_release: {
      get() {
        if (
          this.newQuotationRequest.transaction_type == null ||
          Object.keys(this.newQuotationRequest.incoterm).length === 0
        ) {
          return false;
        }

        return (
          this.newQuotationRequest.incoterm.responsibilities.export_local_charges ==
          this.newQuotationRequest.transaction_type
        );
      },
    },

    show_insurance: {
      get() {
        if (
          this.newQuotationRequest.transaction_type == null ||
          Object.keys(this.newQuotationRequest.incoterm).length === 0
        ) {
          return false;
        }

        return (
          this.newQuotationRequest.incoterm.responsibilities.insurance ==
          this.newQuotationRequest.transaction_type
        );
      },
    },

    show_export_haulage: {
      get() {
        if (
          this.newQuotationRequest.transaction_type == null ||
          Object.keys(this.newQuotationRequest.incoterm).length === 0
        ) {
          return false;
        }

        if (
          this.newQuotationRequest.quotation_type != this.CONSTANT.QUOTATION_TYPE_SEA_FCL
        ) {
          return false;
        }

        return (
          this.newQuotationRequest.incoterm.responsibilities.export_haulage_transport ==
          this.newQuotationRequest.transaction_type
        );
      },
    },

    show_import_haulage: {
      get() {
        if (
          this.newQuotationRequest.transaction_type == null ||
          Object.keys(this.newQuotationRequest.incoterm).length === 0
        ) {
          return false;
        }

        if (
          this.newQuotationRequest.quotation_type != this.CONSTANT.QUOTATION_TYPE_SEA_FCL
        ) {
          return false;
        }

        return (
          this.newQuotationRequest.incoterm.responsibilities.import_haulage_transport ==
          this.newQuotationRequest.transaction_type
        );
      },
    },

    show_export_transport: {
      get() {
        if (
          this.newQuotationRequest.transaction_type == null ||
          Object.keys(this.newQuotationRequest.incoterm).length === 0
        ) {
          return false;
        }

        if (
          this.newQuotationRequest.quotation_type == this.CONSTANT.QUOTATION_TYPE_SEA_FCL
        ) {
          return false;
        }

        return (
          this.newQuotationRequest.incoterm.responsibilities.export_haulage_transport ==
          this.newQuotationRequest.transaction_type
        );
      },
    },

    show_import_transport: {
      get() {
        if (
          this.newQuotationRequest.transaction_type == null ||
          Object.keys(this.newQuotationRequest.incoterm).length === 0
        ) {
          return false;
        }

        if (
          this.newQuotationRequest.quotation_type == this.CONSTANT.QUOTATION_TYPE_SEA_FCL
        ) {
          return false;
        }

        return (
          this.newQuotationRequest.incoterm.responsibilities.import_haulage_transport ==
          this.newQuotationRequest.transaction_type
        );
      },
    },

    require_files: {
      get() {
        if (this.draftQuotation == null) {
          return false;
        }

        if (this.draftQuotation.is_dangerous_goods) {
          return true;
        } else {
          return false;
        }
      },
    },

    enable_file_next: {
      get() {
        if (this.draftQuotation == null) {
          return false;
        }

        if (this.require_files) {
          if (this.skipFileCheck) {
            return true;
          } else if (this.draftQuotation.files.length > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      },
    },
  },
};
</script>

<style scoped>
.container {
  font-size: 12px;
}

.container-btn-alt {
  padding-top: 5px;
  text-align: center;
}

.container h1 {
  font-size: 20px;
  color: #0546f3;
  margin: 0 0 20px;
}

.input-group.group-12 {
  width: 100%;
  padding: 0px;
}

.input-group.group-12 textarea {
  width: 100%;
  border-radius: 4px;
}

.input-group label {
  display: block;
  margin: 0px;
  font-size: 15px;
  margin-bottom: 5px;
}

.input-group .btn-group {
  display: inline-block;
}
.input-group .btn-group a {
  margin-left: -4px;
  background-color: #ffffff;
  border-color: #e0e0e0;
  color: #212121;
  -webkit-transition: all ease-in-out;
  transition: all ease-in-out;
  font-size: 14px;
  padding: 6px 20px;
}

.input-group .btn-group a:first-child {
  margin-left: 0;
}

.input-group .btn-group a.active {
  border-color: #0546f3;
  color: #0546f3;
}

.input-group .inner-input {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
}

.input-group .inner-input input {
  border: 1px solid #e0e0e0;
  border-radius: 4px 0px 0px 4px;
  height: 35px;
  font-size: 14px;
  padding: 0 8px;
  width: 100px;
}

.input-group .inner-input .half-radius {
  margin-left: -1px;
}

.input-group .inner-input .half-radius a {
  border-radius: 0px 4px 4px 0px;
  min-width: 55px;
  font-size: 14px;
}

.input-group .inner-input.dimension input {
  width: 100px;
  margin-left: -1px;
  border-radius: 0px;
}

.input-group .inner-input.dimension input:first-child {
  border-radius: 4px 0px 0px 4px;
}

.input-group .dropdown {
  width: 100%;
}

.input-group .dropdown > a {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  color: #212121;
  display: block;
  width: 100%;
  text-align: left;
}

.input-group .dropdown > a:focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.input-group .dropdown > a:after {
  right: 10px;
  position: absolute;
  top: 50%;
  margin: 0;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}

.input-group .dropdown .dropdown-menu {
  width: 100%;
}

.input-group .dropdown a.disabled {
  background: #f5f5f5;
}

.v-input.v-text-field.em-text-field {
  margin-top: 0px;
  padding-top: 0px;
  border: 0px solid #e0e0e0 !important;
  border-radius: 0px;
}

.inset-row.input-row {
  border: 1px solid #e0e0e0;
  background-color: #f5f5f5;
  padding: 15px;
  margin-left: 0px;
}

.inset-row.input-row .input-group {
  width: auto;
  min-width: 150px;
  padding-right: 0;
  margin-right: 30px;
}

.tooltip-image {
  width: 16px;
  margin-bottom: 4px;
}

/* .addon-option-1 {
  margin-top: 20px;
} */

.v-btn-toggle-new-quotation {
  background-color: inherit !important;
}

.upload-container {
  padding: 10px 0;
  border-top: 1px solid #e0e0e0;
  width: 100%;
  margin-bottom: 40px;
}

.pricing-container {
  margin: 20px 40px;
}

.pricing-container h1 {
  font-size: 20px;
  color: #0546f3;
  margin: 0 10px 20px;
}

.af-addons {
  background-color: #fff;
  border: 0px;
  padding: 0 0;
}
.af-addons input {
  margin-right: 10px;
}
.af-haulage {
  padding: 15px;
}
.af-haulage select {
  margin-top: 10px;
}
.af-haulage label {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 0;
  margin-top: 15px;
}

.af-cargovalue {
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
}
.af-cargovalue select {
  width: 40%;
}
.af-cargovalue.af-p2 {
  padding-bottom: 20px;
}
.af-cargovalue input {
  background: white;
  border: 1px solid #ced4da;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  margin-left: 10px;
}
.af-addons.af-cargovalue {
  background-color: transparent;
}

.af-addons.af-cargovalue input {
  padding: 0 10px 0 0;
  margin-left: 0px;
}

.v-stepper__content {
  background: #f5f6fa;
  height: calc(100vh - 65px);
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
  padding: 0px;
  overflow: auto;
}

.v-stepper__step {
  height: 60px;
  padding: 10px;
  font-size: 12px;
}

::v-deep .v-stepper__step__step {
  background: none !important;
  border: 1px solid #757575 !important;
  width: 30px;
  height: 30px;
  color: black !important;
  font-size: 14px;
}

::v-deep .v-stepper__step .v-stepper__label {
  color: black !important;
}

::v-deep .v-stepper__step.v-stepper__step--active .v-stepper__step__step.primary {
  color: #0546f3 !important;
  background-color: inherit !important;
}
</style>
